import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'compareDate'
})
export class CompareDatePipe implements PipeTransform {
  /**
   *
   * @param date1
   * @param date2
   * @returns 1 if date1 is greater than date2. 0 if equal. -1 otherwise.
   */
  transform(date1: Date | string, date2: Date | string): number {
    const d1 = new Date(date1).getTime();
    const d2 = new Date(date2).getTime();

    return Math.sign(d1 - d2);
  }
}
